import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class Contact extends DynamicFieldsSerializer {
  namespace = 'enrolments';
}
